import React from 'react'
import workingImg from '../../images/working.png'

const About = () => {
  return (
    <section id='about' className='section about'>
      <div className='container'>
        <div className='section-title'>
          <h2>About Rokyet Ventures</h2>
          <p>
            We are a dedicated team of software developers committed to
            delivering innovative solutions that drive business growth.
          </p>
        </div>

        <div className='about-content'>
          <div className='about-text'>
            <h3>Transforming Ideas Into Digital Solutions</h3>
            <p>
              Rokyet Ventures Ltd. is a premier software development company
              with a focus on creating tailored solutions that address specific
              business challenges. Our team combines technical expertise with
              industry knowledge to deliver products that exceed expectations.
            </p>
            <p>
              With years of experience in the software development industry,
              we've helped numerous businesses streamline their operations,
              enhance productivity, and achieve their digital transformation
              goals.
            </p>
          </div>
          <div className='about-image'>
            <div>
              <img
                src={workingImg}
                alt='Working screenshot'
                className='about-img'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
